"use strict";
/*
 * Integration App React package
 * {@link https://www.npmjs.com/package/@integration-app/react}
 * v2.13.0
 */
'use client';

import { WorkspaceElementType } from '@integration-app/sdk';
import { useElement } from '../useElement.mjs';

function useDataSource(selector) {
  const {
    item: dataSource,
    refresh,
    accessor,
    ...rest
  } = useElement(
    WorkspaceElementType.DataSource,
    selector,
    (integrationApp) => selector ? integrationApp.dataSource(selector) : void 0
  );
  async function apply(integrationKeys) {
    const result = await accessor?.apply(integrationKeys);
    await refresh();
    return result ?? [];
  }
  async function reset() {
    await accessor?.reset();
    await refresh();
  }
  return { dataSource, apply, reset, refresh, accessor, ...rest };
}

export { useDataSource };
